<template>
  <div class="shipment-day">
      <v-container class="pa-0 mt-3 mb-1 shipment-day-container" fluid fill-height>
        <v-row no-gutters
          justify="center"
        >
          <v-col cols="8">
            <v-row no-gutters justify="center" align="center">
              <v-col cols="1">
                <check-circle-icon  v-if="isChecked" size="19" class="feather-icon check" :class="[$vuetify.breakpoint.xlOnly ? 'check-xl' : 'check-lg-down']" @click="handleUncheck(day.date)"></check-circle-icon>
                  <circle-icon v-else size="20" class="feather-icon check" :class="[$vuetify.breakpoint.xlOnly ? 'check-xl' : 'check-lg-down']" @click="handleCheck(day.date)"></circle-icon>
              </v-col>

              <v-col cols="2">
                <v-row no-gutters justify="start" :class="[$vuetify.breakpoint.xlOnly ? 'date-xl' : 'date-lg-down', 'wrld_black--text']">
                  {{day.date | dateToReadable($i18n.locale)}}
                </v-row>
              </v-col>

              <v-col cols="2" :class="[$vuetify.breakpoint.xlOnly ? 'stops-xl' : 'stops-lg-down']">
                <v-row no-gutters justify="end">
                  {{day.metrics.stops + ' ' + stopNumber}}
                </v-row>
              </v-col>

              <v-col cols="4" xl="3" :class="[$vuetify.breakpoint.xlOnly ? 'measurement-xl' : 'measurement-lg-down', 'wrld_black--text']">
                <v-row no-gutters justify="end">
                  {{day.metrics.weight | roundValueWeight(0)}} kg &bull; {{day.metrics.volume | roundValue(1)}} m&sup3;
                </v-row>
              </v-col>

              <v-col cols="3" xl="2" :class="[$vuetify.breakpoint.xlOnly ? 'cost-xl' : 'cost-lg-down', 'wrld_black--text']">
                <v-row no-gutters justify="end">
                  {{day.metrics.price.price | humanizeNumber}} {{day.metrics.price.currency}}
                </v-row>
              </v-col>

              <v-col xl="2"></v-col>
            </v-row>
          </v-col>

          <v-col cols="4">
            <v-row no-gutters>
              <v-col cols="6" xl="7">
                <v-row no-gutters justify="center">

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon color="#555555" class="px-2 mb-2" :class="[$vuetify.breakpoint.xlOnly ? 'action-icon-xl' : 'action-icon-lg-down', day.shipments.length > 0 ? '' : $vuetify.breakpoint.xlOnly ? 'no-shipments-xl' : 'no-shipments-lg']" v-on="on" @click="handleOpenPlanner(day.date)">fas fa-chalkboard-teacher</v-icon>
                    </template>
                    <span :class="[$vuetify.breakpoint.xlOnly ? 'tooltip-message-xl' : 'tooltip-message-lg-down']">{{$t('planner.planner')}}</span>
                  </v-tooltip>

                  <ExportShipmentsDay :day="day" v-if="day.shipments.length > 0" />

                  <v-tooltip bottom v-if="day.metrics.warnings && day.metrics.warning !== null">
                    <template v-slot:activator="{ on }">
                      <alert-triangle-icon class="feather-icon" :class="[$vuetify.breakpoint.xlOnly ? 'feather-icon-xl' : 'feather-icon-lg-down']" v-on="on" @click="handleWarning"></alert-triangle-icon>
                    </template>
                    <span v-for="warning in day.metrics.warnings" :key="warning.index" :class="[$vuetify.breakpoint.xlOnly ? 'tooltip-message-xl' : 'tooltip-message-lg-down']">{{warning}} </span>
                  </v-tooltip>
                </v-row>
              </v-col>

              <v-col cols="6" xl="5" :class="[$vuetify.breakpoint.xlOnly ? 'shipment-number-xl' : 'shipment-number-lg-down', 'wrld_black--text']">
                <v-row no-gutters justify="end">
                  {{day.metrics.count + ' ' + shipmentNumber}}
                  <chevron-down-icon v-if="!openShipments" size="1.5x" class="feather-icon arrow-icon ml-1 mr-5" @click="openShipmentList(day)"></chevron-down-icon>
                  <chevron-up-icon v-else size="1.5x" class="feather-icon arrow-icon ml-1 mr-5" @click="closeShipmentList"></chevron-up-icon>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <ul
      v-if="openShipments"
      >
        <li class="shipment-card-list" v-for="shipment in day.shipments" :key="shipment.id">
          <slot name="shipments" :shipment="shipment"></slot>
        </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'
import ExportShipmentsDay from '@/components/shipmentsByDay/ExportShipmentsDay'

export default {
  name: 'DaysMetricMetadata',
  components: {
    ExportShipmentsDay
  },
  props: {
      day: Object,
      open: { type: Boolean, default: false }
  },
  data () {
    return {
      openShipments: false,
      isChecked: false

    }
  },
  computed: {
    ...mapGetters({
      getShipmentDayIsToggled: ['shipmentsGroupByDay/getShipmentDayIsToggled'],
      getShipmentIDsPerDay: 'shipmentsGroupByDay/getShipmentIDsPerDay',
      getShipmentsPerDay: 'shipmentsGroupByDay/getShipmentsPerDay'
    }),
    dayIsToggled () {
      return this.getShipmentDayIsToggled(this.day.date)
    },
    stopNumber () {
      if (this.day.metrics.stops === 1) {
        return this.$i18n.t('shipments.stop')
      } else {
        return this.$i18n.t('shipments.stops')
      }
    },
    shipmentNumber () {
      if (this.day.metrics.count === 1) {
        return this.$i18n.t('shipments.shipment_lower_case')
      } else {
        return this.$i18n.t('shipments.shipments')
      }
    }
  },
  methods: {
    ...mapActions({
      setToggleDay: 'shipmentsGroupByDay/setToggleDay',
      removeToggleDay: 'shipmentsGroupByDay/removeToggleDay'
    }),
    handleCheck (date) {
      this.setToggleDay({date: date})
      this.$emit('day-checked', this.day.date)
    },
    handleUncheck (date) {
      this.removeToggleDay({date: date})
      this.$emit('day-unchecked')
    },
    handlePrint () {
      this.$emit('print')
    },
    handleOpenPlanner (date) {
      const shipments = this.getShipmentsPerDay(date)
      const shipmentDay = shipments[0].pickupLocal.from
      const day = moment(shipmentDay).tz('UTC').set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).unix()
      const shipmentIDs = this.getShipmentIDsPerDay(date)
      this.$router.push({ path: 'planner', query: { day, shipmentIDs } })
      this.$emit('openPlanner')
    },
    handleWarning () {
      this.$emit('warning')
    },
    openShipmentList (day) {
      this.openShipments = true
      this.$emit('openShipmentList')
    },
    closeShipmentList () {
      this.openShipments = false
      this.$emit('closeShipmentList')
    }
  },
  watch: {
    dayIsToggled: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.isChecked = val
      }
    },
    open: {
      immediate: true,
      handler (val) {
        this.openShipments = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .shipment-day {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
  }
  .date-xl {
    font-size: 18px;
    margin-left: 6px;
  }
  .date-lg-down {
    font-size: 15px;
  }
  .stops-xl, .measurement-xl, .cost-xl, .shipment-number-xl {
    font-size: 14px;
  }
  .stops-lg-down, .measurement-lg-down, .cost-lg-down, .shipment-number-lg-down {
    font-size: 12px;
  }
  .check, .action-icon, .arrow-icon, .feather-icon {
    cursor: pointer;
  }
  .shipment-card-list {
    list-style-type: none;
  }
  .check-xl {
    margin-left: 18px;
  }
  .check-lg-down {
    width: 16px;
    height: 16px;
    margin-left: 18px;
  }
  .action-icon-xl {
    font-size: 18px !important;
  }
  .action-icon-lg-down {
    font-size: 14px !important;
  }
  .feather-icon-xl {
    width: 20px;
    height: 20px;
  }
  .feather-icon-lg-down {
    width: 15px;
    height: 15px;
  }
  .tooltip-message-xl {
    font-size: 14px;
  }
  .tooltip-message-lg-down {
    font-size: 12px;
  }
  .no-shipments-xl {
    margin-left: -20px;
  }
  .no-shipments-lg {
    margin-left: -15px;
  }
  .feather-icon {
    vertical-align: middle !important;
  }
</style>
